import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { ROOT_ORGANIZATION } from '@/modules/ProcessingDefinition/ProcessingDefinition.constants';
import { PayoutDefinitionLiteResponse } from '@/modules/ProcessingDefinition/ProcessingDefinition.types';

export const QUERY_KEY = 'GET_PAYOUT_DEFINITIONS_LITE';

const usePayoutDefinitionsLiteQuery = () => {
  const { observingOrganization } = useCurrentOrganization();

  const { data, isLoading } = useQuery(
    [QUERY_KEY, observingOrganization.path],
    () =>
      api.get<PayoutDefinitionLiteResponse[]>(API_URL.PAYOUT_DEFINITIONS_LITE, {
        params: {
          organization_path: observingOrganization.path || ROOT_ORGANIZATION,
        },
      }),
    {
      enabled: !!observingOrganization.path,
    }
  );

  const fieldOptions = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: toString(item.id),
      value: toString(item.id),
      title: item.name || '',
    }));
  }, [data]);

  return {
    fieldOptions,
    isLoading,
  };
};

export default usePayoutDefinitionsLiteQuery;
